import { useState } from "react";

export const InventoryDetailPublish = () => {
    const [tab, setTab] = useState("tab-1");
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">재고 상세보기</h3>
                    <div className="filter_toolbar"></div>
                </div>

                <h5 className="subheading">제품정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>품목명</th>
                            <td colSpan={3}>S1-Emb Std Runtime</td>
                        </tr>
                        <tr>
                            <th>벤더</th>
                            <td style={{ width: "31.3%" }}>MS</td>
                            <th style={{ width: "16.66%" }}>규격</th>
                            <td>7WT-00011</td>
                        </tr>
                        <tr>
                            <th>카테고리</th>
                            <td>Std</td>
                            <th>단위</th>
                            <td>50</td>
                        </tr>
                        <tr>
                            <th>생성일자</th>
                            <td>2024.05.05</td>
                            <th>생성자</th>
                            <td>SYSTEM</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>현재재고 및 내역</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>재고 상세</button>
                </div>
                <div className="mybtns_group_toolbar"></div>
            </div>

            <div className="content_wrap">
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th rowSpan={2} style={{ width: "16.66%", verticalAlign: "middle" }}>현재 재고</th>
                            <td><span className="f-20 medium">12</span></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex">
                                    <button className="btn btn-secondary color2 ms-5px w-100px h-38px rounded ms-0"><img src={process.env.PUBLIC_URL + "/assets/images/btn_icon1.png"} />입고</button>
                                    <button className="btn btn-info ms-5px w-100px h-38px rounded"><img src={process.env.PUBLIC_URL + "/assets/images/btn_icon2.png"} />입고</button>
                                    <button className="btn btn-dark ms-5px w-100px h-38px rounded"><img src={process.env.PUBLIC_URL + "/assets/images/btn_icon3.png"} />조정</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">재고 내역</h3>
                    <div className="filter_toolbar"></div>
                </div>

                <div className="row mb-15px">
                    <div className="col-12">
                        <div className="frm_row_grey">
                            <div className="frm_row search justify-content-start w-100">
                                <label for="" className="form-label frm_label">재고 상태</label>
                                <div className="frm_field">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                        <label className="form-check-label" for="inlineRadio1">입고</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                        <label className="form-check-label" for="inlineRadio2">출고</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio3" value="option3" />
                                        <label className="form-check-label" for="inlineRadio3">조정</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th>상태</th>
                            <th>입출고처</th>
                            <th>수량</th>
                            <th>재고 현황</th>
                            <th>메모</th>
                            <th>변경자</th>
                            <th>변경일자</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[0, 2, 1].map(() => (<tr>
                            <td className="text-center">입고</td>
                            <td className="text-center">회수</td>
                            <td className="text-center"><span className="required">+</span> 2</td>
                            <td className="text-center">8 &gt; 10</td>
                            <td>신규 입고</td>
                            <td className="text-center">홍길동</td>
                            <td className="text-center">2024-05-05</td>
                        </tr>))}
                    </tbody>
                </table>
            </div>
        </>
    );
}